"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const size_const_1 = __importDefault(require("../choices/size.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const modalHeader = {
    padding: size_const_1.default.default2x,
    paddingRightWithButton: `${parseInt(size_const_1.default.medium, 10) + 2 * parseInt(size_const_1.default.default2x, 10)}px`,
    shadowSize: size_const_1.default.shadowSmall,
    shadowColor: color_const_1.default.cloudyBlue300,
    titleFontSize: font_const_1.default.sizeLg,
    titleLineHeight: font_const_1.default.lineHeightLg,
    titleFontWeight: font_const_1.default.weightAttention,
    fontFamily: font_const_1.default.family,
};
exports.default = modalHeader;
